<template>
  <div class="navbar-container d-flex content align-items-center">
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <search-bar />

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-button
        size="sm"
        class="mr-1 onboarding-demo-btn"
        :variant="onboardingDemoState.enabled ? 'outline-danger' : 'outline-primary'"
        @click="handleOnboardingDemo"
      >
        {{ onboardingDemoButtonLabel }}
      </b-button>

      <help />
      <notification-dropdown />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BButton, BNavbarNav } from 'bootstrap-vue'
import {
  getOnboardingDemoButtonLabel,
  startOrResumeOnboardingDemo,
  stopOnboardingDemo,
} from '@/@core/onboarding/controller'
import { getOnboardingDemoState } from '@/@core/onboarding/state'
import SearchBar from './components/SearchBar.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import Help from '../Help.vue'

export default {
  components: {
    BLink,
    BButton,
    BNavbarNav,
    SearchBar,
    NotificationDropdown,
    UserDropdown,
    Help,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      onboardingDemoState: getOnboardingDemoState(),
    }
  },
  computed: {
    onboardingDemoButtonLabel() {
      const { progressVersion } = this.onboardingDemoState

      return progressVersion >= 0
        ? getOnboardingDemoButtonLabel()
        : getOnboardingDemoButtonLabel()
    },
  },
  methods: {
    handleOnboardingDemo() {
      if (this.onboardingDemoState.enabled) {
        stopOnboardingDemo()
        return
      }

      startOrResumeOnboardingDemo()
    },
  },
}
</script>

<style scoped>
.onboarding-demo-btn {
  white-space: nowrap;
}
</style>
